import BaseModel from './BaseModel';

class Vak extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.id = data.id;
    this.name = data.name || "";
    this.amount = data.amount || "";
    this.lease_rental = data.lease_rental || "";
    this.activation_amount = data.amount - data.lease_rental || this.activation_amount || "";
    this.is_rental = data.is_rental || false
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      glk: {
        name: this.name,
        amount: this.amount,
        lease_rental: this.lease_rental,
        activation_amount: this.activation_amount,
        is_rental: this.is_rental
      }
    }
  }

  validations = (field) => {
    return {
      name: () => {
        if(this[field] === "") {
          this.errors.name = "Name cannot be blank.";
        } else {
          delete this.errors.name;
        }
      },
      amount: () => {
        if(this[field] === ""){
          this.errors.amount = "This field should not be empty.";
        } else if(this.amount < this.lease_rental){
          this.errors.amount = "Total Amount should not be greater than Lease Rental Amount.";
        } else{
          delete this.errors.amount;
          delete this.errors.lease_rental;
        }
      },
      lease_rental: () => {
        if(this[field] === ""){
          this.errors.lease_rental = "This field should not be empty.";
        } else if(this.lease_rental > this.amount){
          this.errors.lease_rental = "Lease Rental Amount should not be less than Total Amount.";
        } else{
          delete this.errors.lease_rental;
          delete this.errors.amount;
        }
      },
    }[field];
  }

  validate = (field) => {
    if(this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default Vak
